import * as React from 'react'

import { Box, SearchField, type SortDirection, Table } from '@factorialco/deprecated-design-system'
import orderBy from 'lodash/orderBy'

import { observer } from 'mobx-react'

import createComputed from 'modules/core/hooks/createComputed'
import { useDebouncedSearch } from 'modules/core/hooks/useSearch'
import i18n from 'modules/core/lib/i18n'

import SurveyActions from 'modules/surveys/components/SurveyActions'
import { filterBySearch, filterByStatus } from 'modules/surveys/components/Table/filtering'
import type Survey from 'modules/surveys/store/models/v2/Survey'
import { ISurvey } from 'modules/surveys/store/models/v2/Survey'

import Body from './Body'
import Filters from './Filters'
import Header from './Header'
import { SurveysConfigFilters } from './forms'
import { sortByStatusAsc, sortByStatusDesc } from './sortByStatus'

function SurveysTable() {
  const { search, onSearch } = useDebouncedSearch()
  const [direction, setDirection] = React.useState<SortDirection>('asc')
  const [attribute, setAttribute] = React.useState<string>('status')
  const [status, setStatus] = React.useState<string>('')

  const filtersForm = new SurveysConfigFilters({
    status: status,
  })

  const filteredBySearch = filterBySearch(search)
  const filteredByStatus = filterByStatus(filteredBySearch, status)

  const orderForms = createComputed((filteredByStatus) => {
    if (attribute === 'status') {
      if (direction === 'asc') return sortByStatusAsc(filteredByStatus)

      return sortByStatusDesc(filteredByStatus)
    }

    return orderBy(filteredByStatus, (g: Survey) => g.attributes[attribute as keyof ISurvey], [
      direction,
    ])
  })

  const filteredForms: Survey[] = orderForms(filteredByStatus).get()

  const onSort = (attribute: string, direction: SortDirection) => {
    setDirection(direction)
    setAttribute(attribute)
  }

  const onFilterStatus = (status: string) => setStatus(status)

  const TableOptions = () => (
    <Box flexDirection="row" gap="s8" flexGrow alignItems="center">
      <Filters filtersForm={filtersForm} onFilterStatus={onFilterStatus} />
      <Box width="full">
        <SearchField
          variant="big"
          search={search}
          onSearch={onSearch}
          placeholder={i18n.t('common.search')}
        />
      </Box>
    </Box>
  )

  return (
    <Box alignItems="flexEnd" gap="s16">
      <SurveyActions />
      <Table options={TableOptions} fullWidth>
        <Header onSort={onSort} attribute={attribute} direction={direction} />
        <Body forms={filteredForms} />
      </Table>
    </Box>
  )
}

export default observer(SurveysTable)
